import React from 'react';


import { Box } from 'ui/box';

import MarkdownComponent from 'containers/user/learn/components/markdown/markdown';

interface ParagraphProps {
  title?: string;
  text?: string;
  id: string | number;
}

const Paragraph = ({
  title = '',
  text = '',
  id,
}: ParagraphProps): React.JSX.Element => (
  <Box
    sx={{
      '@media (min-width: 375px)': { mb: 3 },
      '@media (min-width: 960px)': { mb: 4 },
    }}
  >
    {title && (
      <h2
        id={`block_${id}`}
        className="text-2xl font-semibold pb-2 text-neutral-950"
      >
        {title}
      </h2>
    )}
    <MarkdownComponent text={text} />
  </Box>
);

export default Paragraph;
